import { Component } from '@theme/component';

/** Explicit privacy opener. It never writes a consent choice or tracking state.
 * @extends {Component<{status?: HTMLElement}>}
 */
class CybexoReview extends Component {
  /** Open the existing CMP only after the visitor's button activation. */
  openPrivacy() {
    const status = this.refs.status;
    try {
      if (typeof window.openCMPSettings === 'function' && window.openCMPSettings() !== false) {
        if (status) status.textContent = '';
        return;
      }
    } catch (_) { /* The visitor's existing consent remains unchanged. */ }
    if (status) status.textContent = this.dataset.loadingMessage || '';
  }
}

if (!customElements.get('cybexo-review')) customElements.define('cybexo-review', CybexoReview);
